import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./ButtonsBar.css";

function ButtonsBar() {
  const location = useLocation(); // Получаем текущий путь

  // Массив объектов для кнопок
  const buttons = [
    { to: "/property-development", label: "PROPERTY DEVELOPMENT", className: "button1" },
    { to: "/construction-materials", label: "CONSTRUCTION MATERIALS", className: "button2" },
    { to: "/investment-opportnites", label: "INVESTMENT OPPORTUNITIES", className: "button3" },
    { to: "/gallery", label: "GALLERY", className: "button3" }
  ];

  return (
    <section className="buttons-bar">
      {buttons.map((button, index) =>
        location.pathname !== button.to ? ( 
          <Link key={index} className={`buttons-bar__button ${button.className}`} to={button.to}>
            {button.label}
          </Link>
        ) : null 
      )}
    </section>
  );
}

export default ButtonsBar;
